import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ViewStateService {

  private isListViewSubject = new BehaviorSubject<boolean>(false);
  private isViewedCardsSubject = new BehaviorSubject<boolean>(true);
  private isClearHistorySubject = new BehaviorSubject<boolean>(false);
  private isCancelSubscriptionSubject = new BehaviorSubject<boolean>(false);
  private isClearHistoryActiveSubject = new BehaviorSubject<boolean>(false);
  private isActiveCancelSubscriptionSubject = new BehaviorSubject<boolean>(false);
  private showTextTitleAndLengthSubject = new BehaviorSubject<string>('');

  isListView$ = this.isListViewSubject.asObservable();
  isViewedCards$ = this.isViewedCardsSubject.asObservable();
  isClearHistory$ = this.isClearHistorySubject.asObservable();
  isCancelSubscription$ = this.isCancelSubscriptionSubject.asObservable();
  isClearHistoryActiveOnHeader$ = this.isClearHistoryActiveSubject.pipe()
  isActiveCancelSubscription$ = this.isActiveCancelSubscriptionSubject.asObservable();
  showTextTitleAndLengthSubject$ = this.showTextTitleAndLengthSubject.asObservable();

  setListView(isListView: boolean): void {
    this.isListViewSubject.next(isListView);
  }

  setIsViewedCards(isViewedCards: boolean): void {
    this.isViewedCardsSubject.next(isViewedCards);
  }

  setIsClearHistory(isClearHistory: boolean): void {
    this.isClearHistorySubject.next(isClearHistory);
  }

  setIsCancelSubscription(isCancelSubscription: boolean): void {
    this.isCancelSubscriptionSubject.next(isCancelSubscription);
  }

  setIsClearHistoryActiveOnHeader(isClearHistoryActiveOnHeader: boolean): void {
    this.isClearHistoryActiveSubject.next(isClearHistoryActiveOnHeader);
  }

  setIsActiveCancelSubscription(isActiveCancelSubscription: boolean): void {
    this.isActiveCancelSubscriptionSubject.next(isActiveCancelSubscription);
  }

  setCardsNameAndLength(cardsNameAndLength: string): void {
    this.showTextTitleAndLengthSubject.next(cardsNameAndLength)
  }
}
